import React from 'react'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'
import moment from 'moment'

import config from './config'

export const getEntityType = (typeCd) => {
    const {
        entityTypes: { company, entrepreneur, person },
        entityNames: { COMPANY, ENTREPRENEUR, PERSON, GROUP },
    } = config

    if (company.indexOf(typeCd) !== -1) return COMPANY
    if (entrepreneur.indexOf(typeCd) !== -1) return ENTREPRENEUR
    if (person.indexOf(typeCd) !== -1) return PERSON

    return GROUP
}

export const isEntityInactive = (inactiveIndicator) => inactiveIndicator === '01'

export const getEntityIconClassNames = (entity) =>
    cx(`type-${getEntityType(entity.get('typeCd'))}`, isEntityInactive(entity.get('inacInd')) && 'inactive')

export const getEntityText = (entity) => {
    const regNumber = entity.get('regNbr') ? (
        <FormattedMessage id={'components.Entity.ico'} values={{ ico: entity.get('regNbr') }} />
    ) : null

    const bornDate = entity.get('strtDt') ? (
        <FormattedMessage
            id={'components.Entity.born'}
            values={{ born: moment(entity.get('strtDt'), 'YYYYMMDD').format('DD. MM. YYYY') }}
        />
    ) : null

    return regNumber || bornDate || ''
}
